const Elm = require("../elm/src/Filters");

function initFilters(elmDiv, flags = {}) {
  console.log(Elm)
  const elmApp = Elm.Main.embed(elmDiv);
}

export { initFilters }


// WEBPACK FOOTER //
// ./js/filters.js